var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8224 5.13966C9.88636 2.9372 7.34212 1.91055 5.13966 2.84658C2.9372 3.7826 1.91055 6.32684 2.84658 8.5293C3.7826 10.7318 6.32684 11.7584 8.5293 10.8224C9.04466 10.6034 9.49564 10.2963 9.87215 9.92615C9.88041 9.91654 9.88908 9.90718 9.89819 9.89808C9.9072 9.88907 9.91646 9.88048 9.92596 9.8723C11.1173 8.65899 11.5289 6.80198 10.8224 5.13966ZM10.9433 10.2362C12.1719 8.74962 12.5491 6.64602 11.7427 4.74853C10.5907 2.03778 7.45927 0.774201 4.74853 1.92624C2.03778 3.07828 0.774201 6.20969 1.92624 8.92043C3.07828 11.6312 6.20969 12.8948 8.92043 11.7427C9.40773 11.5356 9.84825 11.2646 10.2364 10.9435L13.6466 14.3541C13.8418 14.5494 14.1584 14.5494 14.3537 14.3542C14.5489 14.1589 14.549 13.8424 14.3537 13.6471L10.9433 10.2362Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/search-white.5fc93c5b07fd6a9334f40ae642d74321.svg";
export { ForwardRef as ReactComponent };